import { render } from "./ManageGroupMembers.vue?vue&type=template&id=651150d7"
import script from "./ManageGroupMembers.vue?vue&type=script&lang=js"
export * from "./ManageGroupMembers.vue?vue&type=script&lang=js"
script.render = render

export default script